import { call, getContext } from 'redux-saga/effects';
import type { LinkIntent, PublishLinkIntentOptions } from 'src/services/WorkspaceService';
import type { WorkspaceLinkingActions } from 'src/store/actions/widgets/linking';
import type { SagaContext } from 'src/store/types';

export const LEGACY_LINK_BRIDGE_OPTIONS = {
    bridgeToLegacy: false,
} satisfies PublishLinkIntentOptions;

export function isWorkspaceLinkingBridgeAction(action: { type: string }): action is WorkspaceLinkingActions {
    switch (action.type) {
        case 'workspaceLinkingInstrumentSelected':
        case 'workspaceLinkingAccountSelected':
        case 'workspaceLinkingQuantitySelected':
        case 'workspaceLinkingOrderSelected':
            return true;
        default:
            return false;
    }
}

export function* publishLinkIntentFromLegacy(action: LinkIntent) {
    const ctx: SagaContext['container'] = yield getContext('container');
    const workspaceService = ctx.get('WorkspaceService');
    yield call([workspaceService, workspaceService.publishLinkIntent], action, LEGACY_LINK_BRIDGE_OPTIONS);
}
